module.exports = __webpack_public_path__ + "img/art1-img3.13f4380b.jpeg";